"use client";

export type UrlChangeReason =
	| "navigation"
	| "scroll-spy"
	| "filter"
	| "modal"
	| "other";

export interface UrlChangeDetail {
	reason: UrlChangeReason;
	/** Caller tag (e.g. `"marketing-landing-section"`). */
	source?: string;
}

export const URL_CHANGE_EVENT = "sq:url-change";

function dispatchUrlChange(detail: UrlChangeDetail & { url?: string }) {
	if (typeof window === "undefined") {
		return;
	}
	window.dispatchEvent(
		new CustomEvent(URL_CHANGE_EVENT, {
			detail: {
				...detail,
				url: detail.url ?? window.location.href,
			},
		}),
	);
}

/** Wraps `history.pushState` and notifies listeners (analytics, etc.). */
export function pushStateAndNotify(
	url: string,
	detail: Omit<UrlChangeDetail, never>,
): void {
	if (typeof window === "undefined") {
		return;
	}
	window.history.pushState(null, "", url);
	dispatchUrlChange({ ...detail, url: window.location.href });
}

/** Wraps `history.replaceState` and notifies listeners (analytics, etc.). */
export function replaceStateAndNotify(
	url: string,
	detail: Omit<UrlChangeDetail, never>,
): void {
	if (typeof window === "undefined") {
		return;
	}
	window.history.replaceState(null, "", url);
	dispatchUrlChange({ ...detail, url: window.location.href });
}

/** Call after a manual URL mutation so listeners stay coherent. */
export function notifyUrlChanged(detail: UrlChangeDetail): void {
	dispatchUrlChange(detail);
}
